/* eslint-disable import/prefer-default-export */
import styled from '@emotion/styled';
import { Box } from '@mui/material';

export const VideoBox = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5%;
`;
